import { Box, Button, Flex, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TableActions from '../../common/TableActions/TableActions';
import TableHeader from '../../common/TableHeader/TableHeader';
import useItemLister from '../../core/hooks/useItemLister';
import { AIFeedback } from '../../core/models/aiFeedback';

const FILTERS = ['title', 'user', 'question', 'page', 'rating'];

const COLS: {
  label: string;
  sort?: string;
  isNumeric?: boolean;
}[] = [
  {
    label: 'Title',
    sort: 'title',
  },
  {
    label: 'Rating',
    sort: 'rating',
  },
  {
    label: 'CreatedAt',
    sort: 'created',
  },
  {
    label: 'Page',
    sort: 'page',
  },
  {
    label: 'User',
    sort: 'user',
  },
  {
    label: 'Question',
    sort: 'question',
  },
];

function AIFeedbackLister() {
  const { items, Lister, sort, changeSort, setIsActive } = useItemLister({
    endpointSingle: 'ai_feedback',
    endpointPlural: 'ai_feedbacks',
    filters: FILTERS,
    perPage: 50,
  });

  useEffect(() => {
    setIsActive(true);

    return () => {
      setIsActive(false);
    };
  }, []);

  return (
    <>
      <Flex>
        <h1 className="h3">AI Feedback</h1>
      </Flex>
      {Lister({
        children: (
          <Box my={5}>
            <TableContainer fontSize="1rem" boxShadow="xl">
              <Table variant="striped" colorScheme="facebook">
                <TableHeader cols={COLS} sort={sort} changeSort={changeSort} />
                <Tbody>
                  {items?.map((item: AIFeedback) => (
                    <Tr key={item._id}>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item.title}
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item.rating}
                      </Td>

                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {new Date(item.created).toLocaleString('en-gb', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          color: '#218ce7',
                        }}
                      >
                        <a href={item.page} target="_blank" rel="noopener noreferrer">
                          {item.page}
                        </a>
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item.user}
                      </Td>
                      <Td
                        p={2}
                        verticalAlign="middle"
                        style={{
                          padding: '6px',
                          maxWidth: '200px',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                        }}
                      >
                        {item.question}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        ),
      })}
    </>
  );
}

export default AIFeedbackLister;
